import React from 'react'

export default function UploadsEmpty() {
  return (
    <div className="rounded bg-darken p-5 text-center text-muted">
      There are no uploads to display
    </div>
  )
}
